import { Component, OnInit } from "@angular/core";

@Component({
    selector: 'app-terms',
    templateUrl: './terms.html'
  })
  export class TermsComponent implements OnInit {
    ngOnInit(): void {
    }
  }